import React, { useContext, useEffect, useState } from "react";
import { Table } from "flowbite-react";
import { useNavigate } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";
import Validate from "../shared/validation/Validate";
import axios from "axios";
import { UserContext } from "../context";
import Loader from "../shared/Loader/Loader";

const ForeignCurrencyBalance = () => {
    const navigate = useNavigate();

    const { state } = useContext(UserContext);

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    const [currencyRates, setCurrencyRates] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if(userDetail && userDetail.userRole ==='Admin' && userDetail.shopId === undefined){
            navigate('/shopSelection');
        }
    }, [])

    useEffect(() => {
        const fetchCurrencies = async () => {
            try {
                setIsLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL + `getAllForeignCurrenciesWithDifference`, {
                    params: {
                        shopId: userDetail?.shopId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const currencies = response.data;

                setCurrencyRates(currencies);
                setIsLoading(false)
            } catch (error) {
                console.log(error);
                setIsLoading(false)
            }
        };
        fetchCurrencies();
    }, [])

    return (
        <Validate>
            <div className="">
                {isLoading? <Loader />: ''}
                <div className="">
                    {/* <h1 className="text-headings text-3xl font-medium mt-10">Foreign Currency Balance</h1> */}
                </div>
                <div className="h-[500px] overflow-x-auto bg-gray-50 dark:bg-gray-900 rounded-lg shadow-md">
                    <Table className="h-[500px]">
                        <Table.Head className="sticky top-0 z-10 bg-theme-secondary">
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Currency</Table.HeadCell>
                            {/* <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Description</Table.HeadCell> */}
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Opening Balance</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg flex'>New</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Difference</Table.HeadCell>
                            <Table.HeadCell style={{ textTransform: 'none' }} className='bg-theme-secondary text-white font-medium text-lg'>Action</Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="divide-y">
                            {currencyRates.map((val, index) => (
                                <Table.Row key={index} className="bg-slate-200 dark:border-gray-700 dark:bg-gray-800">
                                    <Table.Cell className="whitespace-nowrap font-bold text-lg text-theme-primary flex">&nbsp;&nbsp;&nbsp;&nbsp;{val.currency}<FaArrowRightLong className="mx-1 mt-1" />{val.country}</Table.Cell>
                                    {/* <Table.Cell>Lorem ipsum dolor sit amet sonsecterue. Lorem ipsum dolor sit amet consectetur.</Table.Cell> */}
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.openingBalance}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left">&nbsp;&nbsp;&nbsp;&nbsp;{val.totalBalance || '0'}</Table.Cell>
                                    <Table.Cell className="font-semibold text-lg text-left"><span className={`ml-2 font-semibold text-lg ${val.totalBalance > val.openingBalance ? "text-red-500" : val.totalBalance < val.openingBalance ? "text-green-500" : ""}`}>{val.totalBalance < val.openingBalance ? "+" : val.totalBalance > val.openingBalance ? "" : ""}</span><span className={`ml-2 font-semibold text-lg ${val.totalBalance > val.openingBalance ? "text-red-500" : val.totalBalance < val.openingBalance ? "text-green-500" : ""}`}>&nbsp;{val.difference}</span></Table.Cell>
                                    <Table.Cell>&nbsp;&nbsp;&nbsp;&nbsp;<button className='bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 py-2 rounded-lg' onClick={() => navigate(`/foreignCurrencyPage/${val.currency}/${val.country}`)}>Open</button></Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </Validate>
    )
}

export default ForeignCurrencyBalance;